import { render } from "./ReservationIndex.vue?vue&type=template&id=abace882"
import script from "./ReservationIndex.vue?vue&type=script&lang=js"
export * from "./ReservationIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__